// Dourado vocabulary expansion — HOUSE & HOME theme (net-new cards).
//
// Extends the `house` blocks in ./vocabulary.js without reusing any headword
// already defined there. Seed upserts on `portuguese`, so every value is unique.
//   [ portuguese, english, emoji, part_of_speech, gender, example_pt, example_en ]

export const VOCAB_HOUSE = [
  {
    theme: "house", tier: "A1", rows: [
      ["a divisão", "room", "🚪", "noun", "f", "A minha divisão é pequena.", "My room is small."],
      ["a parede", "wall", "🧱", "noun", "f", "A parede é branca.", "The wall is white."],
      ["o espelho", "mirror", "🪞", "noun", "m", "Vejo-me ao espelho.", "I look at myself in the mirror."],
      ["a chave", "key", "🔑", "noun", "f", "Não encontro a chave.", "I can't find the key."],
      ["o prato", "plate", "🍽️", "noun", "m", "O prato está sujo.", "The plate is dirty."],
      ["o copo", "glass", "🥛", "noun", "m", "Quero um copo de água.", "I want a glass of water."],
      ["a luz", "light", "💡", "noun", "f", "Apaga a luz, por favor.", "Turn off the light, please."],
      ["o duche", "shower", "🚿", "noun", "m", "O duche está avariado.", "The shower is broken."],
      ["limpar", "to clean", "🧽", "verb", "", "Limpo a casa aos sábados.", "I clean the house on Saturdays."],
      ["o rés-do-chão", "ground floor", "🏢", "phrase", "", "Vivo no rés-do-chão.", "I live on the ground floor."],
    ],
  },
  {
    theme: "house", tier: "A2", rows: [
      ["o móvel", "piece of furniture", "🪑", "noun", "m", "Comprámos um móvel novo.", "We bought a new piece of furniture."],
      ["o tapete", "rug / carpet", "🧶", "noun", "m", "O tapete é muito macio.", "The rug is very soft."],
      ["a cortina", "curtain", "🪟", "noun", "f", "Corre as cortinas.", "Draw the curtains."],
      ["a gaveta", "drawer", "🗄️", "noun", "f", "As chaves estão na gaveta.", "The keys are in the drawer."],
      ["a torneira", "tap", "🚰", "noun", "f", "A torneira pinga.", "The tap is dripping."],
      ["a tomada", "plug / socket", "🔌", "noun", "f", "Não há tomada por perto.", "There's no socket nearby."],
      ["o lavatório", "sink", "🧼", "noun", "m", "O lavatório está entupido.", "The sink is blocked."],
      ["a máquina de lavar", "washing machine", "🧺", "noun", "f", "Ponho a máquina de lavar à noite.", "I run the washing machine at night."],
      ["o forno", "oven", "🔥", "noun", "m", "O pão está no forno.", "The bread is in the oven."],
      ["a varanda", "terrace / balcony", "🪴", "noun", "f", "Tomamos o pequeno-almoço na varanda.", "We have breakfast on the terrace."],
    ],
  },
  {
    theme: "house", tier: "B1", rows: [
      ["o senhorio", "landlord", "🏠", "noun", "m", "O senhorio aumentou a renda.", "The landlord raised the rent."],
      ["o contrato de arrendamento", "rental contract", "📄", "phrase", "", "Assinámos o contrato de arrendamento.", "We signed the rental contract."],
      ["a caução", "deposit", "💶", "noun", "f", "Paguei um mês de caução.", "I paid a month's deposit."],
      ["a habitação", "housing / dwelling", "🏘️", "noun", "f", "A habitação é muito cara aqui.", "Housing is very expensive here."],
      ["as despesas", "expenses / bills", "🧾", "noun", "f", "As despesas não estão incluídas.", "Bills are not included."],
      ["renovar", "to renovate", "🔨", "verb", "", "Vamos renovar a cozinha.", "We're going to renovate the kitchen."],
      ["o sótão", "attic", "🏚️", "noun", "m", "Guardamos coisas no sótão.", "We keep things in the attic."],
      ["a cave", "basement", "🕳️", "noun", "f", "A cave está húmida.", "The basement is damp."],
      ["espaçoso", "spacious", "📐", "adjective", "", "A sala é muito espaçosa.", "The living room is very spacious."],
      ["o condomínio", "residents' association", "👥", "noun", "m", "Pagamos o condomínio todos os meses.", "We pay the residents' fee each month."],
    ],
  },
];
